import { Eye, Users } from 'lucide-react';
import { useState } from 'react';
import Button from 'shared/components/Button';
import FormField from 'shared/components/form/FormField';
import Modal from 'shared/components/modal/Modal';
import { inputClass } from 'shared/theme/colorTokens';
import { EventApplicantModel } from '../../models/Evento';

interface Props {
  applicants: EventApplicantModel[];
}

const EventoApplicantsSection = ({ applicants }: Props) => {
  const [selected, setSelected] = useState<EventApplicantModel | null>(null);

  return (
    <div className="min-w-0 rounded-2xl border border-white bg-whiteLight p-6 dark:border-white/10 dark:bg-darkLight">
      <div className="mb-4 flex items-center gap-2">
        <Users size={18} className="text-secondary-500" />
        <h2 className="text-lg font-semibold text-ink dark:text-ink-dark">
          Solicitantes
        </h2>
        <span className="rounded-full bg-secondary-50 px-2.5 py-0.5 text-xs font-medium text-secondary-700 dark:bg-white/10 dark:text-secondary-200">
          {applicants.length}
        </span>
      </div>
      <div className="flex max-h-60 flex-col gap-3 overflow-y-auto pr-1">
        {applicants.length === 0 && (
          <p className="text-sm text-inkMuted dark:text-inkMuted-dark">
            Todavía no hay solicitantes vinculados.
          </p>
        )}
        {applicants.map((applicant) => (
          <div
            key={applicant.id}
            className="flex items-center justify-between gap-3 rounded-xl border border-secondary-50 px-4 py-3 dark:border-white/5"
          >
            <div className="flex min-w-0 items-center gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-semibold text-secondary-700 dark:bg-white/10 dark:text-secondary-200">
                {applicant.name
                  .split(' ')
                  .map((part) => part[0])
                  .slice(0, 2)
                  .join('')
                  .toUpperCase()}
              </span>
              <div className="min-w-0 break-words">
                <p className="text-sm font-medium text-ink dark:text-ink-dark">
                  {applicant.name}
                </p>
                {applicant.email && (
                  <p className="text-xs text-inkMuted dark:text-inkMuted-dark">
                    {applicant.email}
                  </p>
                )}
              </div>
            </div>
            <button
              type="button"
              aria-label={`Ver detalle de ${applicant.name}`}
              onClick={() => setSelected(applicant)}
              className="shrink-0 text-inkMuted transition hover:text-secondary-600 dark:text-inkMuted-dark dark:hover:text-secondary-300"
            >
              <Eye size={15} />
            </button>
          </div>
        ))}
      </div>
      <Modal
        open={selected !== null}
        onClose={() => setSelected(null)}
        title="Detalle del solicitante"
        footer={
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => setSelected(null)}
          >
            Cerrar
          </Button>
        }
      >
        {selected && (
          <div className="flex flex-col gap-4">
            <FormField label="Nombre" htmlFor="applicant-name">
              <input
                id="applicant-name"
                className={inputClass}
                value={selected.name}
                disabled
              />
            </FormField>
            <FormField label="Email" htmlFor="applicant-email">
              <input
                id="applicant-email"
                className={inputClass}
                value={selected.email || 'No informado'}
                disabled
              />
            </FormField>
            <FormField label="Teléfono" htmlFor="applicant-phone">
              <input
                id="applicant-phone"
                className={inputClass}
                value={selected.phone || 'No informado'}
                disabled
              />
            </FormField>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default EventoApplicantsSection;
